import React, { useState, useEffect, useCallback } from "react";
import API from "../services/api";
import Swal from "sweetalert2";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import "../styles/billing.css";

export default function ViewSale({ setView }) {
    const [history, setHistory] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchType, setSearchType] = useState("name");
    const [searchVal, setSearchVal] = useState("");
    const [stats, setStats] = useState({ today: 0, yesterday: 0 });

    const fetchHistory = useCallback(async () => {
        try {
            const res = await API.get(`/billing/history?page=${page}&search=${searchVal}&type=${searchType}`);
            if (res.data.success) {
                setHistory(res.data.invoices);
                setTotalPages(res.data.totalPages);
                setStats({ today: res.data.today, yesterday: res.data.yesterday });
            }
        } catch (err) { console.error("History fetch error", err); }
    }, [page, searchVal, searchType]);

    const deleteInvoice = async (id) => {

        const confirm = await Swal.fire({
            title: "Delete Bill?",
            text: "Ye permanently delete ho jayega!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes Delete"
        })

        if (!confirm.isConfirmed) return

        await API.delete(`/billing/deleteUser/${id}`)

        Swal.fire({
            title: "Deleted!",
            icon: "success",
            timer: 1000,
            showConfirmButton: false
        })

        fetchHistory()
    }

    useEffect(() => {
        fetchHistory();
    }, [fetchHistory]);

    // const viewItems = (invoice) => {
    //     Swal.fire({
    //         title: `Items for ${invoice.customerName}`,
    //         html: `
    //             <table style="width:100%; border-collapse: collapse; color: white; background: #0f172a;">
    //                 <thead>
    //                     <tr style="border-bottom: 2px solid #38bdf8;">
    //                         <th style="padding: 8px; text-align: left;">Item</th>
    //                         <th style="padding: 8px;">Qty</th>
    //                         <th style="padding: 8px;">Price</th>
    //                     </tr>
    //                 </thead>
    //                 <tbody>
    //                     ${invoice.items.map(item => `
    //                         <tr style="border-bottom: 1px solid #334155;">
    //                             <td style="padding: 8px; text-align: left;">${item.name} ${item.unit || ""}</td>
    //                             <td style="padding: 8px;">${item.qty} ${item.unit ? item.unit : ""}</td>
    //                             <td style="padding: 8px;">₹${item.price}</td>
    //                         </tr>
    //                     `).join('')}
    //                 </tbody>
    //             </table>
    //             <div style="margin-top: 15px; text-align: right; color: #38bdf8;">
    //                 <div><b>Discount: ₹${invoice.discount || 0}</b></div>
    //                 <b>Paid: ₹${invoice.paidAmount || 0} | Due: ₹${invoice.dueAmount || 0}</b>
    //             </div>
    //         `,
    //         showDenyButton: true,
    //         denyButtonText: "Return Item",

    //         background: '#0f172a', confirmButtonColor: '#38bdf8'
    //     });


    // };


    const viewItems = async (invoice) => {

        const { value: formValues } = await Swal.fire({
            title: `Items for ${invoice.customerName}`,
            width: "850px",
            background: "#0f172a",
            color: "white",
            confirmButtonText: "Confirm Return",
            showCancelButton: true,

            html: `
        <table style="width:100%; border-collapse: collapse; font-size:14px;">
            <thead>
                <tr style="border-bottom:2px solid #38bdf8;">
                    <th style="padding:10px; text-align:left;">Item</th>
                    <th style="padding:10px;">Qty</th>
                    <th style="padding:10px;">Price</th>
                    <th style="padding:10px;">Return</th>
                </tr>
            </thead>
            <tbody>
                ${invoice.items.map((item, index) => `
                    <tr style="border-bottom:1px solid #334155;">
                        <td style="padding:10px;">${item.name}</td>
                        
                        <td style="padding:10px;">
                            ${item.qty} ${item.unit ? item.unit : ""}
                        </td>

                        <td style="padding:10px;">₹${item.price}</td>

                        <td style="padding:10px;">
                            <input 
                                type="text"
                                id="return-${index}"
                                placeholder="1 or 1kg or 2.5 feet"
                                style="
                                    width:100px;
                                    padding:5px;
                                    border-radius:6px;
                                    border:1px solid #334155;
                                    background:#020617;
                                    color:white;
                                "
                            />
                        </td>
                    </tr>
                `).join("")}
            </tbody>
        </table>
        `,

            preConfirm: () => {

                const itemsToReturn = invoice.items.map((item, index) => {

                    const val = document.getElementById(`return-${index}`).value.trim()

                    if (!val) return null

                    // 🔥 TEXT → NUMBER (1kg, 2feet, 3)
                    const number = parseFloat(val)

                    if (isNaN(number) || number <= 0) return null

                    return {
                        itemId: item._id,
                        productId: item.productId,
                        returnQty: number
                    }

                }).filter(Boolean)

                if (itemsToReturn.length === 0) {
                    Swal.showValidationMessage("Valid return qty likho!")
                    return false
                }

                return itemsToReturn
            }
        })

        if (!formValues) return

        try {

            // 🔥 MULTIPLE RETURNS
            await API.post("/billing/return", {
                invoiceId: invoice._id,
                items: formValues
            })

            Swal.fire({
                title: "Return Success",
                icon: "success",
                timer: 1200,
                showConfirmButton: false
            })

            fetchHistory() // 🔥 instant refresh

        } catch {
            Swal.fire("Error", "Return failed", "error")
        }
    }



    const downloadReportPDF = (customerName, data, type) => {
        try {
            const doc = new jsPDF("p", "mm", "a4");

            const money = (amount) => `Rs. ${Number(amount || 0).toFixed(2)}`;

            doc.setFillColor(15, 23, 42);
            doc.rect(0, 0, 210, 30, "F");

            doc.setTextColor(255, 255, 255);
            doc.setFontSize(18);
            doc.text("BHOPAL SEAT COVER", 14, 13);

            doc.setFontSize(11);
            doc.text(`Customer: ${customerName || "-"}`, 14, 22);

            doc.setTextColor(0, 0, 0);

            let y = 40;

            data.forEach((inv, index) => {
                const status = Number(inv.dueAmount || 0) === 0 ? "PAID" : "UNPAID";

                autoTable(doc, {
                    startY: y,
                    theme: "grid",
                    head: [[`Bill ${index + 1}`, "Details"]],
                    body: [
                        ["Date", new Date(inv.date).toLocaleDateString("en-IN")],
                        ["Subtotal", money(inv.subTotal)],
                        ["Discount", money(inv.discount)],
                        ["Total", money(inv.totalAmount)],
                        ["Paid", money(inv.paidAmount)],
                        ["Due", money(inv.dueAmount)],
                        ["Status", status],
                    ],
                    headStyles: {
                        fillColor: [15, 23, 42],
                        textColor: 255,
                    },
                    styles: {
                        fontSize: 9,
                        cellPadding: 2,
                    },
                });

                y = doc.lastAutoTable.finalY + 4;

                const itemRows = (inv.items || []).map((item, i) => {
                    const qty = Number(item.qty || 0);
                    const price = Number(item.price || 0);

                    return [
                        i + 1,
                        item.name || "-",
                        `${qty} ${item.unit || ""}`,
                        money(price),
                        money(qty * price),
                    ];
                });

                autoTable(doc, {
                    startY: y,
                    theme: "striped",
                    head: [["#", "Item", "Qty / Unit", "Price", "Amount"]],
                    body: itemRows.length
                        ? itemRows
                        : [["-", "No items found", "-", "-", "-"]],
                    headStyles: {
                        fillColor: [56, 189, 248],
                        textColor: 255,
                    },
                    styles: {
                        fontSize: 8.5,
                        cellPadding: 2,
                    },
                });

                y = doc.lastAutoTable.finalY + 8;

                if (y > 260) {
                    doc.addPage();
                    y = 20;
                }
            });

            doc.save(`${customerName || "customer"}_report.pdf`);

        } catch (error) {
            Swal.fire("Error", "PDF error!", "error");
        }
    };

    const handleReportFlow = async (inv) => {
        const result = await Swal.fire({
            title: "Select Range",
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: "📅 Same Date",
            denyButtonText: "📚 All Time",
        });

        if (result.isDismissed) return;

        const sameDate = new Date(inv.date).toISOString().split("T")[0];
        const type = result.isConfirmed ? "date" : "all";

        const res = await API.get(
            `/billing/report/${inv.customerMobile || "N/A"}?type=${type}&date=${sameDate}&name=${inv.customerName}`
        );

        if (res.data.success) {
            downloadReportPDF(inv.customerName, res.data.reports, type);
        }
    };



    return (
        <div className="history-panel-premium">
            <div className="stats-row" style={{ display: 'flex', gap: '20px', marginBottom: '25px' }}>
                <div className="stat-pill" style={{ border: '1px solid #22c55e', padding: '15px', borderRadius: '12px', flex: 1 }}>
                    <span style={{ color: '#94a3b8', fontSize: '12px' }}>TODAY'S SALE</span>
                    <h2 style={{ color: '#22c55e' }}>₹{stats.today}</h2>
                </div>
                <div className="stat-pill" style={{ border: '1px solid #38bdf8', padding: '15px', borderRadius: '12px', flex: 1 }}>
                    <span style={{ color: '#94a3b8', fontSize: '12px' }}>YESTERDAY'S SALE</span>
                    <h2 style={{ color: '#38bdf8' }}>₹{stats.yesterday}</h2>
                </div>
            </div>

            <div className="history-filters">
                <select className="bsc-select" onChange={(e) => setSearchType(e.target.value)}>
                    <option value="name">Search Name</option>
                    <option value="mobile">Search Mobile</option>
                </select>
                <input className="bsc-input-search" type="text" placeholder={`Type ${searchType}...`} onChange={(e) => setSearchVal(e.target.value)} />
            </div>

            <table className="bsc-table">
                <thead>
                    <tr>
                        <th>Date</th><th>Customer</th><th>Total</th><th>Paid</th><th>Due</th><th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {history.map((inv) => (
                        <tr key={inv._id}>
                            <td>{new Date(inv.date).toLocaleDateString()}</td>
                            <td>{inv.customerName}</td>
                            <td>₹{Math.max(0, inv.totalAmount)}</td>
                            <td style={{ color: '#22c55e' }}>₹{inv.paidAmount}</td>
                            <td style={{ color: inv.dueAmount > 0 ? '#ef4444' : '#94a3b8' }}>
                                ₹{Math.max(0, inv.dueAmount)}
                            </td>


                            <td className="actions-cell">

                                {inv.totalAmount === 0 ? (
                                    <button
                                        className="delete-btn bsc-action-btn delete-btn-premium  "
                                        onClick={() => deleteInvoice(inv._id)}
                                    >
                                        🗑 Delete
                                    </button>
                                ) : (
                                    <>
                                        <button className="bsc-action-btn   view-btn-premium view-btn"
                                            onClick={() => viewItems(inv)}> <i className="fas fa-eye"></i>View</button>
                                        <button className="bsc-action-btn pdf-btn-premium pdf-btn"
                                            onClick={() => handleReportFlow(inv)}><i className="fas fa-file-pdf"></i> PDF </button>
                                    </>
                                )}

                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="bsc-pagination">
                <button disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
                <span>Page {page} / {totalPages}</span>
                <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
            </div>
        </div>
    );
}